import { useCallback, useState } from 'react';

export const useToggle = (initial: boolean) => {
  const [open, setOpen] = useState(initial);

  const toggle = useCallback(
    (newValue?: boolean) =>
      setOpen(newValue !== undefined ? newValue : status => !status),
    []
  );

  return [open, toggle] as const;
};
